import { useState, useEffect, useRef } from "react";
import { Input } from "@/components/ui/input";
import { Building2, Search } from "lucide-react";

let _cache = null;
async function loadOffices() {
  if (_cache) return _cache;
  const mod = await import("@/lib/taxOffices.json");
  const arr = mod.default || mod;
  _cache = arr.map((o) => ({ daire: o.daire, il: o.il, ilce: o.ilce }));
  return _cache;
}

const trLower = (s) => (s || "").toLocaleLowerCase("tr-TR");

export function TaxOfficePicker({ value, onChange, testid = "tax-office", placeholder = "Vergi dairesi yazın veya seçin", disabled }) {
  const [offices, setOffices] = useState([]);
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState(value || "");
  const boxRef = useRef(null);

  useEffect(() => { loadOffices().then(setOffices).catch(() => {}); }, []);
  useEffect(() => { setQ(value || ""); }, [value]);
  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const term = trLower(q).trim();
  const matches = term.length < 1 ? [] : offices.filter((o) => trLower(o.daire).includes(term) || trLower(o.il).includes(term)).slice(0, 40);

  const pick = (o) => { onChange(o.daire); setQ(o.daire); setOpen(false); };

  return (
    <div ref={boxRef} className="relative mt-1" data-testid={`${testid}-wrap`}>
      <div className="relative">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-slate-400" />
        <Input data-testid={testid} disabled={disabled} value={q} placeholder={placeholder} autoComplete="off"
          onChange={(e) => { setQ(e.target.value); onChange(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)} className="pl-8" />
      </div>
      {open && matches.length > 0 && (
        <div data-testid={`${testid}-list`} className="absolute z-50 mt-1 max-h-64 w-full overflow-y-auto rounded-lg border border-slate-200 bg-white py-1 shadow-lg">
          {matches.map((o, i) => (
            <button key={`${o.daire}-${i}`} type="button" data-testid={`${testid}-opt-${i}`}
              onMouseDown={(e) => { e.preventDefault(); pick(o); }}
              className="flex w-full items-start gap-2 px-3 py-1.5 text-left text-sm transition-colors hover:bg-brand-green/5">
              <Building2 className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-green" />
              <span className="min-w-0">
                <span className="block truncate font-medium text-slate-700">{o.daire}</span>
                <span className="text-[11px] text-slate-400">{o.il}{o.ilce && o.ilce !== "Merkez" ? ` · ${o.ilce}` : ""}</span>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default TaxOfficePicker;
